import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject, takeUntil } from 'rxjs';

import { AppFacade } from 'ish-core/facades/app.facade';
import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { CategoryView } from 'ish-core/models/category-view/category-view.model';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';

import { CategoryCategoriesComponent } from './category-categories/category-categories.component';
import { CategoryProductsComponent } from './category-products/category-products.component';

@Component({
  selector: 'ish-category-page',
  templateUrl: './category-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CategoryCategoriesComponent, CategoryProductsComponent, AsyncPipe],
})
export class CategoryPageComponent implements OnInit, OnDestroy {
  private shoppingFacade = inject(ShoppingFacade);
  private appFacade = inject(AppFacade);
  private activatedRoute = inject(ActivatedRoute);

  category$: Observable<CategoryView>;
  deviceType$: Observable<DeviceType>;
  forceProductListing = false;
  private destroy$ = new Subject<void>();

  ngOnInit() {
    this.category$ = this.shoppingFacade.selectedCategory$;
    this.deviceType$ = this.appFacade.deviceType$;
    this.activatedRoute.queryParamMap.pipe(takeUntil(this.destroy$)).subscribe(queryParamMap => {
      if (queryParamMap.has('isRefinement')) {
        this.forceProductListing = queryParamMap.get('isRefinement') !== 'false';
      } else {
        this.forceProductListing = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
